var _rect, _path, _rect2, _path2, _rect3, _path3, _rect4, _path4, _rect5, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllstar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 30,
    viewBox: "0 0 198 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "#00B67A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 20.27L21.18 24L19.54 16.97L25 12.24L17.81 11.63L15 5L12.19 11.63L5 12.24L10.46 16.97L8.82 24L15 20.27Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    width: 30,
    height: 30,
    rx: 4,
    fill: "#00B67A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57 20.27L63.18 24L61.54 16.97L67 12.24L59.81 11.63L57 5L54.19 11.63L47 12.24L52.46 16.97L50.82 24L57 20.27Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    width: 30,
    height: 30,
    rx: 4,
    fill: "#00B67A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99 20.27L105.18 24L103.54 16.97L109 12.24L101.81 11.63L99 5L96.19 11.63L89 12.24L94.46 16.97L92.82 24L99 20.27Z",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    width: 30,
    height: 30,
    rx: 4,
    fill: "#00B67A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M141 20.27L147.18 24L145.54 16.97L151 12.24L143.81 11.63L141 5L138.19 11.63L131 12.24L136.46 16.97L134.82 24L141 20.27Z",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 168,
    width: 30,
    height: 30,
    rx: 4,
    fill: "#00B67A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M183 20.27L189.18 24L187.54 16.97L193 12.24L185.81 11.63L183 5L180.19 11.63L173 12.24L178.46 16.97L176.82 24L183 20.27Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllstar);
export default __webpack_public_path__ + "static/media/allstar.cd176b1adf06e8102062e12eb5dcf508.svg";
export { ForwardRef as ReactComponent };